<template>
  <vs-table hover-flat v-if="records" :data="records">
    <template slot="thead">
      <vs-th class="text-center" v-text="$t('status')"></vs-th>
      <vs-th class="text-center" v-text="$t('date_time')"></vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td class="text-center">
          <span v-if="tr.status" v-text="$t(tr.status)"></span>
        </vs-td>
        <vs-td class="text-center">
          <span v-if="tr.datetime" v-text="tr.datetime"></span>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

export default {
  name: 'Shared.ExtensionStatusDataAnalysis.StatusList',
  props: {
    records: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
